import React, { useEffect, useState } from 'react';

import { Modal, Surface } from '@infoods/lifebase-ui';
import { Slide } from '@mui/material';

import classes from './HelpCenterWidget.module.scss';
import { LeadConnectorChat } from '../../../integrations';
import { WelcomeCard } from './WelcomeCard/WelcomeCard';

type HelpCenterWidgetProps = {
  open: boolean;
  onClose: () => void;
};

const HelpCenterWidget = ({ open, onClose }: HelpCenterWidgetProps) => {
  const [view, setView] = useState<'welcome' | 'chat'>('welcome');
  const [chatMounted, setChatMounted] = useState(false); // to load the chat container only when the chat view is active

  useEffect(() => {
    if (view === 'chat') {
      setChatMounted(true);
    }
  }, [view]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      className={classes.modalRoot}
      disableEnforceFocus
      // a chat the user started must still be there when the panel is reopened, so the
      // chat stays mounted for the widget's life and is only hidden while it is not shown
      keepMounted
    >
      <Slide direction="left" in={open} onExited={() => setView('welcome')}>
        <Surface className={classes.panel} variant="elevated" radius="m">
          {view === 'welcome' && (
            <WelcomeCard onClose={onClose} onStartChat={() => setView('chat')} />
          )}
          {chatMounted && (
            <div hidden={view !== 'chat'}>
              <LeadConnectorChat onClose={onClose} />
            </div>
          )}
        </Surface>
      </Slide>
    </Modal>
  );
};

export { HelpCenterWidget };
